export default __webpack_public_path__ + "static/media/piece_of_aerosiderite.a598f873.png";